import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M57 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C28.834 7 6 29.834 6 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M80.52 106.74a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M42.561 98.44a1.5 1.5 0 0 1 0 2.121l-10 9.99a1.5 1.5 0 1 1-2.121-2.122l10-9.99a1.5 1.5 0 0 1 2.121 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M30.439 98.44a1.5 1.5 0 0 1 2.121-.001l10 9.99a1.5 1.5 0 1 1-2.12 2.122l-10-9.99a1.5 1.5 0 0 1-.001-2.121"
      clipRule="evenodd"
    />
    <path fill="#00D8D8" d="M85.2 96.74a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M31.26 6a1.5 1.5 0 0 1 1.5 1.5v14.13a1.5 1.5 0 0 1-3 0V7.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M22.69 14.56a1.5 1.5 0 0 1 1.5-1.5h14.13a1.5 1.5 0 1 1 0 3H24.19a1.5 1.5 0 0 1-1.5-1.5M101.68 32.24a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path fill="#00D8D8" d="M11 74c0-28.168 20.15-51 45-51s45 22.832 45 51" />
    <path
      fill="#0597A3"
      d="M46 26.081V74h20V26.081C66 20.537 61.494 16 56 16s-10 4.537-10 10.081M108 80c0 1.65-1.363 3-3.03 3H9.03C7.363 83 6 81.65 6 80v-3c0-1.65 1.363-3 3.03-3h95.94c1.667 0 3.03 1.35 3.03 3zM42 62.2c0 2.09-1.579 3.8-3.5 3.8S35 64.29 35 62.2V27.8c0-2.09 1.579-3.8 3.5-3.8s3.5 1.71 3.5 3.8zM77 62.2c0 2.09-1.579 3.8-3.5 3.8S70 64.29 70 62.2V27.8c0-2.09 1.579-3.8 3.5-3.8s3.5 1.71 3.5 3.8z"
    />
  </svg>
);
const SvgEnrichedIconContractorInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconContractorInverted);
export default Memo;
